import { Segmented } from "antd";
import React, { useState } from "react";

export default function Tarix() {
  let [sections, setSections] = useState("YUK XATLARI");

  return (
    <div className="flex flex-row items-center  justify-center">
      <Segmented
        size="large"
        options={["YUK XATLARI", "TICKETLAR"]}
        value={sections}
        onChange={(val) => {
          setSections(val);
        }}
        style={{
          transform: "scale(1.2)", // Increase size by 1.2x
          transformOrigin: "center", // Keep it centered
        }}
      />
    </div>
  );
}
